<template>
    <div class='competitionDetailBox'>
        <CompetitionDetail :form="form"></CompetitionDetail>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <Button @handleClick="$router.push({path:'/consultant/minestudent/main/studentMessage/competition/list'})" :type="'btnGray'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue'
import CompetitionDetail from '@/components/consultant/CompetitionDetail.vue'
export default {
    name: "competitionDetailBox",
    components: {
        Button,
        CompetitionDetail
    },
    data() {
        return {
            swiperIndex: 0,
            id:this.$route.query.id,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            form: {}
            // form: {
            //     "id": 3,
            //     "studentId": 4,
            //     "type": 2,
            //     "name": "赛事名称",
            //     "degree": "市级二等奖",
            //     "date": "2020-12-23",
            //     "organizationalUnit": "组织单位",
            //     "personalTeam": 2,
            //     "picUrl": ["\/data\/img\/20201230\/1609325368527Explosion_1080.jpg", "\/data\/img\/20201230\/1609325368278Explosion_4k.jpg", "\/data\/img\/20201230\/1609325368298Burner-1080.jpg", "\/data\/img\/20201230\/1609325368221Aurora-1080.jpg", "\/data\/img\/20201230\/1609325368697Burner-4k.jpg"],
            //     "createdAt": "2020-12-30 18:49:28",
            //     "updatedAt": "2020-12-30 18:49:28",
            //     "deletedAt": null,
            //     "typeName": "科技创新类",
            //     "personalTeamName": "团体"
            // }
        }
    },
    created() {
        if(this.id) {
          this.detailAchievement();
        }else {
            this.form  = JSON.parse(window.sessionStorage.getItem("formCompetition"));
            // console.log(this.form)
        }
    },
    methods: {
      // 获取竞赛详情
      detailAchievement(){
        let id = this.$route.query.id;
        let studentId = this.studentId;
        this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.competition.detailAchievement, {
          studentId: studentId,
          id:id
        }, {
          headers: {
            token: window.sessionStorage.getItem('ymtxToken')
          }
        }).then((res) => {
          if (res.data.code == 2000) {
            this.form = res.data.data;
          }
        })
      },
    },
}
</script>
<style scoped lang="less">
.competitionDetailBox {

}
</style>